//loader.service.ts
import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  public isLoading = new BehaviorSubject(false);
  public message = new BehaviorSubject<string | null>(null);

  private activeRequests = 0;
  private activeProcesses = 0;

  private messageInterval?: ReturnType<typeof setInterval>;
  private messageIndex = 0;

  // Los requests que salen de acciones NGXS corren fuera de la zona de Angular: se emite
  // dentro de la zona para que el loader se repinte al terminar, sin esperar otro evento.
  constructor(private zone: NgZone) {}

  requestStarted(): void {
    this.activeRequests++;
    this.updateLoadingState();
  }

  requestFinished(): void {
    this.activeRequests = Math.max(0, this.activeRequests - 1);
    this.updateLoadingState();
  }

  startProcess(
    messages: string[] = [],
    messageIntervalMs = 4000
  ): void {
    this.activeProcesses++;
    if (messages.length) {
      this.startMessages(messages, messageIntervalMs);
    }

    this.updateLoadingState();
  }

  stopProcess(): void {
    this.activeProcesses = Math.max(0, this.activeProcesses - 1);

    if (this.activeProcesses === 0) {
      this.stopMessages();
    }

    this.updateLoadingState();
  }

  private updateLoadingState(): void {
    const loading = this.activeRequests > 0 || this.activeProcesses > 0;
    this.zone.run(() => this.isLoading.next(loading));
  }

  private startMessages(
    messages: string[],
    intervalMs: number
  ): void {
    this.stopMessages();

    this.messageIndex = 0;
    this.zone.run(() => this.message.next(messages[0]));

    this.messageInterval = setInterval(() => {
      this.messageIndex =
        (this.messageIndex + 1) % messages.length;

      this.zone.run(() => this.message.next(messages[this.messageIndex]));
    }, intervalMs);
  }

  private stopMessages(): void {
    if (this.messageInterval) {
      clearInterval(this.messageInterval);
      this.messageInterval = undefined;
    }

    this.zone.run(() => this.message.next(null));
  }
}
